var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPrescriptionCard = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 120 120"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 60,
  cy: 60,
  r: 60,
  fill: "#F6F9FC"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#E4E9ED",
  d: "M46.189 31.757a5 5 0 0 1 4.481 5.47l-4.34 43.614a5 5 0 0 1-5.489 4.479l-11.885-1.225a5 5 0 0 1-4.463-5.47l4.344-43.568a5 5 0 0 1 5.469-4.48l11.883 1.18Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeWidth: 1.667,
  d: "m31.345 30.275 62.529 6.181a2 2 0 0 1 1.793 2.187l-4.884 49.412a2 2 0 0 1-2.187 1.793l-62.529-6.18a2 2 0 0 1-1.793-2.188l4.884-49.411a2 2 0 0 1 2.187-1.794Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "m62.118 49.394 10.087.997M60.999 58l20.174 1.994M59.499 71.334l20.174 1.994M60.165 64.667l20.174 1.994"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#F6F9FC",
  d: "m38.998 43.583 14 1.417-.332 4.416h-1.917v2.334c1.306.528 3.75 2.483 3.083 6.083-.667 3.6-1.722 12.222-2.166 16.083l-17.167-1.833 1.583-17.75c.277-1.028 1.416-3.166 3.75-3.5l.25-2.583-1.75-.417.666-4.25Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#88B04B",
  d: "M40.097 56.642a2.167 2.167 0 0 1 2.37-1.944l11.424 1.13-1.81 18.317L38.5 72.803l1.597-16.161Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#CAE2BB",
  d: "m48.523 55.297 4.737.468-1.842 18.633-4.737-.468z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  stroke: "#36485C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.667,
  d: "m50.525 51.744.24-2.428 1.42.14a.5.5 0 0 0 .547-.448l.356-3.6a.5.5 0 0 0-.449-.547l-13.418-1.327a.5.5 0 0 0-.546.449l-.356 3.6a.5.5 0 0 0 .448.547l1.42.14-.244 2.464c-1.086.247-2.056.787-2.778 1.55a4.602 4.602 0 0 0-1.263 2.714l-1.583 16.02a1.5 1.5 0 0 0 1.345 1.64l14.878 1.47a1.5 1.5 0 0 0 1.64-1.345l1.584-16.017a4.608 4.608 0 0 0-.738-2.959c-.58-.9-1.455-1.62-2.503-2.063ZM51.08 49.333l-10.737-1.061"
})));
export default SvgPrescriptionCard;